"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _default(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
}